<form [formGroup]="formGroup" class="mrc">
  @if (headerElement) {
    <div class="mrc-page-header">
      <b>{{ getQuestionTitle(headerElement.title) }}</b>
    </div>
  }

  <div class="mrc-guide">
    <div class="mrc-guide-title">{{ "MRC_GuideTitle" | translate }}</div>
    <ul class="mrc-guide-list">
      @for (grade of grades; track grade) {
        <li>
          <span class="mrc-guide-grade">{{ grade }}</span>
          <span>{{ "MRC_Grade" + grade | translate }}</span>
        </li>
      }
    </ul>
    <p class="mrc-guide-note">{{ "MRC_WholeNumbers" | translate }}</p>
  </div>

  <div class="mrc-row mrc-columns">
    <div class="mrc-columns-muscle">{{ "Muscle" | translate }}</div>
    <div class="mrc-columns-score">{{ "MRC_ScoreRange" | translate }}</div>
    <div class="mrc-side">{{ "Left" | translate }}</div>
    <div class="mrc-side">{{ "Right" | translate }}</div>
  </div>
  @for (element of muscleElements; track element.name) {
    <div class="mrc-row">
      <div class="mrc-q-title">
        {{ getQuestionTitle(element.title) }}
        @if (isInvalid(element)) {
          <div class="mrc-error">
            {{ "Enter a grade from 0 to 5" | translate }}
          </div>
        }
      </div>
      @for (side of sides; track side) {
        <input
          type="text"
          class="mrc-input"
          inputmode="numeric"
          maxlength="1"
          [attr.aria-label]="(side === 'left' ? 'Left' : 'Right') | translate"
          [formControl]="getSideControl(element.name, side)"
        />
      }
    </div>
  }

  @if (totalElement) {
    <div class="mrc-score mrc-total">
      <div class="mrc-score-title">
        {{ getQuestionTitle(totalElement.title) }}
      </div>
      <div class="mrc-score-value">{{ getTotalDisplay() }} / {{ maxTotal }}</div>
    </div>
  }
</form>
